<p>app-entry-point works!</p>
